var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.path === '/englishList')?_c('page',[_c('listTemplate',{attrs:{"page-title":"List","pid":_vm.$cid.english.hotel,"page-size":6,"type":"list"},on:{"article-click":_vm.articleClick}})],1):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fadf8fc0","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/english/list.vue
// module id = 1474
// module chunks = 0